/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviewDocument/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Empty from './Empty/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PreviewDocument({
  children,
  onSubmit,
  viewPath = "/DesignSystem/PreviewDocument"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let previewDocumentDocumentIdValueData = fromData.useDataFormat({ viewPath,
context: 'preview_document',
path: 'document_id',
format: fromHelpers.view,
})
let previewDocumentDocumentIdSubmitData = fromData.useDataSubmit({ viewPath,
context: 'preview_document',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: previewDocumentDocumentIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}